export const discardMember = index => {
  return {
    type: `TEAM_MEMBER_${index}_DISCARD`,
    index: index
  }
}
